var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "90px",
    viewBox: "0 0 105 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---old",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "donations-copy",
    transform: "translate(-168.000000, -264.000000)",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(161.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1313867,47.3397656 L80.1657852,47.3397656 C80.9777148,49.5627148 81.4212988,51.9616895 81.4212988,54.4620547 L81.4212988,84.5674258 C81.4212988,85.6098984 81.2398418,86.6105273 80.9097187,87.5411484 L94.0786309,87.5411484 C98.9978867,87.5411484 102.999799,83.5390352 102.999799,78.6199805 L102.999799,62.2081777 C102.999799,54.0098203 96.3299453,47.3397656 88.1313867,47.3397656 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5787012,54.4622559 C21.5787012,51.9616895 22.0222852,49.562916 22.8342148,47.3399668 L14.8686133,47.3399668 C6.67005469,47.3399668 0,54.0100215 0,62.2085801 L0,78.6203828 C0,83.5394375 4.00191211,87.5415508 8.92116797,87.5415508 L22.0902812,87.5415508 C21.7601582,86.6105273 21.5787012,85.6100996 21.5787012,84.567627 L21.5787012,54.4622559 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6052402,39.5936426 L42.3947598,39.5936426 C34.1962012,39.5936426 27.5261465,46.2636973 27.5261465,54.4622559 L27.5261465,84.567627 C27.5261465,86.209793 28.857502,87.5413496 30.4998691,87.5413496 L72.5001309,87.5413496 C74.142498,87.5413496 75.4738535,86.2099941 75.4738535,84.567627 L75.4738535,54.4622559 C75.4738535,46.2636973 68.8037988,39.5936426 60.6052402,39.5936426 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,0.168984375 C41.6401641,0.168984375 33.6186367,8.19051172 33.6186367,18.0505488 C33.6186367,24.7385078 37.3099395,30.5795332 42.7612949,33.6461973 C45.346957,35.1006699 48.3279219,35.9319121 51.5,35.9319121 C54.6720781,35.9319121 57.653043,35.1006699 60.2387051,33.6461973 C65.6902617,30.5795332 69.3813633,24.7383066 69.3813633,18.0505488 C69.3813633,8.19071289 61.3598359,0.168984375 51.5,0.168984375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1006914,16.835873 C12.7267363,16.835873 6.72779102,22.8348184 6.72779102,30.2087734 C6.72779102,37.5827285 12.7267363,43.5816738 20.1006914,43.5816738 C21.9711875,43.5816738 23.7523633,43.1942168 25.3703887,42.4977598 C28.1678848,41.2933437 30.4745215,39.1613242 31.9018359,36.4907676 C32.9036719,34.6164492 33.4735918,32.4781934 33.4735918,30.2087734 C33.4735918,22.8350195 27.4746465,16.835873 20.1006914,16.835873 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8993086,16.835873 C75.5253535,16.835873 69.5264082,22.8348184 69.5264082,30.2087734 C69.5264082,32.4783945 70.0963281,34.6166504 71.0981641,36.4907676 C72.5254785,39.1615254 74.8321152,41.2935449 77.6296113,42.4977598 C79.2476367,43.1942168 81.0288125,43.5816738 82.8993086,43.5816738 C90.2732637,43.5816738 96.272209,37.5827285 96.272209,30.2087734 C96.272209,22.8348184 90.2732637,16.835873 82.8993086,16.835873 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTeams);
export default __webpack_public_path__ + "static/media/NoTeams.bfd75b809e9e8fd501e39dec77512d4b.svg";
export { ForwardRef as ReactComponent };